<template>
  <el-tabs v-model="tabPaneVal" type="border-card" @tab-click="handleClick">
    <el-tab-pane label="托运人资料" name="ShipmentEdit">
      <ShipmentEdit
        v-if="isShipmentEditShow"
        ref="ShipmentEditRef"
        :parent-data="parentData"
      />
    </el-tab-pane>
    <el-tab-pane v-if="!ctmsShow" label="开票信息管理" name="InvoiceMessage">
      <InvoiceMessage
        v-if="isInvoiceMessageShow"
        ref="InvoiceMessageRef"
        :parent-data="parentData"
      />
    </el-tab-pane>
    <el-tab-pane label="地址管理" name="CommonRouteInfo">
      <CommonRouteInfo
        v-if="isCommonRouteInfoShow"
        ref="CommonRouteInfoRef"
        :parent-data="parentData"
      />
    </el-tab-pane>
    <el-tab-pane v-if="!ctmsShow" label="承运分组" name="VehicleTeam">
      <VehicleTeam
        v-if="isVehicleTeamShow"
        ref="VehicleTeamRef"
        :parent-data="parentData"
      />
    </el-tab-pane>
    <el-tab-pane v-if="!ctmsShow" label="合同管理" name="ShipmentContract">
      <ShipmentContract
        v-if="isShipmentContractShow"
        ref="ShipmentContractRef"
        :parent-data="parentData"
      />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import ShipmentEdit from "./components/shipmentEdit.vue";
import InvoiceMessage from "./components/invoiceMessage/invoiceMessageList.vue";
import CommonRouteInfo from "./components/commonRouteInfo/commonRouteInfoList.vue";
import VehicleTeam from "./components/vehicleTeam/vehicleTeamList.vue";
import ShipmentContract from "./components/shipmentContract/shipmentContractList.vue";
import { getListDict, getShipperList, getGoodsTypeDict } from "@/api/shipment";
import { getRole } from "@/utils/getRole";
export default {
  name: "EditShipmentForm",
  components: {
    ShipmentEdit,
    InvoiceMessage,
    CommonRouteInfo,
    VehicleTeam,
    ShipmentContract
  },
  data() {
    return {
      companyCode: "",
      parentData: {
        areaOptions: this.$store.state.components.areaOptions,
        receiverUserCodeOptions: [],
        typeOptions: [],
        vehicleDictList: [],
        bankOptions: [],
        branchCode: ""
      },
      queryData: {},
      tabPaneVal: "ShipmentEdit",
      isShipmentEditShow: true,
      isInvoiceMessageShow: false,
      isCommonRouteInfoShow: false,
      isVehicleTeamShow: false,
      isPriceSystemShow: false,
      isCustomerManageShow: true,
      isLineManagementShow: false,
      isShipmentContractShow: false,
      ctmsShow: false,
      tab: {}
    };
  },
  watch: {
    // 监听路由刷新
    // '$route':function(route){
    //   if(route.query.code&&route.path.indexOf("editShipmentCompanyForm")>-1){
    //     this.tabPaneVal = 'ShipmentEdit'
    //     this.isShipmentEditShow = true
    //     this.isInvoiceMessageShow = false
    //     this.isCommonRouteInfoShow = false
    //     this.isVehicleTeamShow = false
    //     this.isPriceSystemShow = false
    //     this.isCustomerManageShow = true
    //     this.isLineManagementShow = false
    //     this.isShipmentContractShow = false
    //   }
    // }
  },
  created() {
    this.ctmsShow = getRole();
    this.queryData = this.$route.query;
    this.companyCode = this.queryData.code || "";
    this.parentData.branchCode = this.queryData.branchCode;
    // 收票人选项
    getShipperList({ staffTypes: "0,4,6", companyCode: this.companyCode }).then(
      response => {
        this.parentData.receiverUserCodeOptions = response.data.records;
      }
    );
    // 货物类型字典
    getGoodsTypeDict({ parentCode: "goodsBigType" }).then(response => {
      this.parentData.goodsTypeList = response.data.records;
    });
    // 开票方式、车型、开户银行
    getListDict({ types: "vehicleClassification, bank" }).then(response => {
      //个人托运人，只有 0 现付开票
      this.parentData.typeOptions = this.parentData.typeOptions.filter(
        item => item.code === "0"
      );
      this.parentData.vehicleDictList = response.data.filter(
        item => item.type === "vehicleClassification"
      )[0]["dictList"];
      this.parentData.bankOptions = response.data.filter(
        item => item.type === "bank"
      )[0]["dictList"];
    });
  },
  methods: {
    handleClick(tab, event) {
      this.tab = tab;
      this[`is${tab.name}Show`] = true;
      this.$nextTick(() => {
        this.$refs[`${tab.name}Ref`].findList();
      });
    }
  }
};
</script>
